import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=e4d78f1c&scoped=true&"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts&"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=e4d78f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d78f1c",
  null
  
)

export default component.exports